<div class="newNavbar fixed-top px-1">
    <div class="contentNavBar">
        <ng-content>

        </ng-content>
    </div>
</div>